'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var MaterialTable = _interopDefault(require('@material-ui/core/Table'));

var StyledTable = styled__default(MaterialTable)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  &.root {\n    background-color: ", ";\n    table-layout: fixed;\n    border: 1px solid ", ";\n    border-bottom: 0 none;\n    width: 100%;\n  }\n"], ["\n  &.root {\n    background-color: ", ";\n    table-layout: fixed;\n    border: 1px solid ", ";\n    border-bottom: 0 none;\n    width: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
});
var Table = function (_a) {
    var children = _a.children, _b = _a.stickyHeader, stickyHeader = _b === void 0 ? true : _b, restProps = tslib_es6.__rest(_a, ["children", "stickyHeader"]);
    return (React__default.createElement(StyledTable, tslib_es6.__assign({ stickyHeader: stickyHeader }, restProps, { classes: { root: 'root' } }), children));
};
var templateObject_1;

exports.Table = Table;
